import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlanTypeInlineListComponent } from './plan-type-inline-list/plan-type-inline-list.component';
import { PlanTypeComponent } from './plan-type/plan-type.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [PlanTypeInlineListComponent, PlanTypeComponent],
  imports: [CommonModule, MatTooltipModule],
  exports: [PlanTypeInlineListComponent, PlanTypeComponent],
})
export class PlanTypesModule {}
